// UI-brain client (TASK-499). Posts a typed query to the generative-UI brain and gets
// back a reply + widget specs to push onto the canvas. Mirrors SixEase api/orchestrate.ts.
// The server resolves the client name->id within the RM's visible set and injects it —
// the frontend never sends or receives a raw client id it authored.
import { httpClient } from '../../lib/httpClient';
import type { WidgetSpec } from '../../registry/types';

export interface ChatTurn {
  role: 'user' | 'assistant';
  content: string;
}

export interface OrchestrateUIRequest {
  /** TASK-651: active UI language (i18n code) — replies follow it. */
  language?: string;
  query: string;
  // Canvas focus (the last summoned client) — a hint the server honours only if visible.
  client_id?: string | null;
  // TASK-707: the meeting already open on the canvas. A HINT: the server uses it only after
  // checking it belongs to the focused client, so a stale tile can never open someone else's
  // meeting. The model never sees it and never emits one.
  session_id?: string | null;
  // TASK-706: the page the RM is on. Carried into an escalated (work) turn through the same
  // ChatContext the deep-chat path already sends — one context builder, not two.
  route?: string | null;
  history?: ChatTurn[];
}

export interface OrchestrateUIResponse {
  reply: string;
  specs: WidgetSpec[];
  client_id?: string | null;
  client_name?: string | null;
}

export const orchestrateApiService = {
  resolve(body: OrchestrateUIRequest) {
    return httpClient.post<OrchestrateUIResponse>('/api/orchestrate-ui', body);
  },
};
